import { resolveStoreByIp } from '@gozoki/api'
import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  redirect,
} from '@tanstack/react-router'
import { ErrorPage } from '~/pages/ErrorPage'
import { HomePage } from '~/pages/HomePage'
import { getToken, setToken } from '~/utils/api'

const rootRoute = createRootRoute({
  component: Outlet,
})

const errorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/error',
  component: ErrorPage,
})

// Route protégée : plus de login. Sans token, on résout la boutique via l'IP publique du device.
// IP reconnue → token boutique émis, dashboard affiché. IP inconnue → page d'erreur.
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: async () => {
    const token = await getToken()
    if (token) return
    try {
      const { token: issued } = await resolveStoreByIp()
      await setToken(issued)
    } catch {
      throw redirect({ to: '/error' })
    }
  },
  component: HomePage,
})

const routeTree = rootRoute.addChildren([indexRoute, errorRoute])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
